import { render, staticRenderFns } from "./CompanyReportFormModal.vue?vue&type=template&id=10fb94e6"
import script from "./CompanyReportFormModal.vue?vue&type=script&lang=js"
export * from "./CompanyReportFormModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyReportFormModal.vue?vue&type=style&index=0&id=10fb94e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports